import React from 'react'
import { useMutation } from 'react-apollo'
import { useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import useServerError from '../../../src/hooks/useServerError'
import { Form, FormIdentifier } from '../forms/FieldFactory'
import FormBuilder from '../../components/forms/FormBuilder'
import SignInMutation from '../../graphql/SignInMutation.gql'
import {
  BasicType,
  ElementType,
} from '../../../src/components/forms/FormElementParts'
import { FormData } from '../../../src/components/forms/FormCollector'

const form: Form = {
  fields: [
    {
      icon: 'Email',
      label: 'Email',
      name: 'email',
      type: ElementType.EMAIL,
    },
    {
      icon: 'Key',
      label: 'Password',
      name: 'password',
      type: ElementType.PASSWORD,
    },
    {
      label: 'Sign In',
      type: BasicType.SUBMIT,
    },
    {
      label: "<a href='/password/new'>Forgot Password?</a>",
      type: BasicType.FOOTER,
    },
    {
      label: "<a href='/invitation/resend'>Lost Invitation?</a>",
      type: BasicType.FOOTER,
    },
  ],
  header: 'Sign In',
  type: FormIdentifier.SIGN_IN,
}

const registrationLink = (window as any).CMD.config.tenant.registration
if (registrationLink && registrationLink.length) {
  form.fields.push({
    label: `Don't Have an Account? <a href="${registrationLink}">Register Here</a>`,
    type: BasicType.FOOTER,
  })
} else {
  form.fields.push({
    label: "Don't Have an Account? <a href='/register'>Register Here</a>",
    type: BasicType.FOOTER,
  })
}

const faqLink = (window as any).CMD.config.tenant.faq
if (faqLink && faqLink.length) {
  form.fields.push({
    label: `<a href="${faqLink}" rel="noopener noreferrer" target="_blank">Click Here to View FAQ</a>`,
    type: BasicType.FOOTER,
  })
}

export default () => {
  const history = useHistory()
  const [signIn, { data, error }] = useMutation(SignInMutation)
  const { clearServerError, serverError, setServerError } = useServerError()
  const handleSubmitForm = React.useCallback(
    (formData: FormData) => {
      signIn({
        variables: {
          ...formData,
          clientId: (window as any).CMD.config.tenant.client_id,
          clientSecret: (window as any).CMD.config.tenant.client_secret,
        },
      })
    },
    [signIn],
  )
  React.useEffect(() => {
    if (error && error.graphQLErrors.length) {
      const err: any = error.graphQLErrors[0]
      setServerError({ message: err.message, errors: err.fields })
    } else {
      clearServerError()
    }
  }, [clearServerError, error, setServerError])
  const signInData = data && data.signIn
  const accessToken = signInData && signInData.accessToken
  const redirectUri = signInData && signInData.redirectUri
  const credentialId = signInData && signInData.resourceOwnerId
  if (accessToken) {
    window.location.href = '/'
  } else if (redirectUri) {
    if (redirectUri.indexOf('/') === 0) {
      history.push(redirectUri, { credentialId })
    }
  }
  return (
    <React.Fragment>
      <Helmet
        title={`${(window as any).CMD.config.tenant.page_title} - Sign In`}
      />
      <FormBuilder
        form={form}
        key={form.type}
        onChange={clearServerError}
        onSubmit={handleSubmitForm}
        serverError={serverError}
      />
    </React.Fragment>
  )
}
